import {SPECIALIZATION} from "../../../../../Config/ApiUrl";
import DeleteMixin from "../../../../../Mixins/DeleteMixin";

export default {
    mixins: [DeleteMixin],
    props: ['id', 'props'],
    data() {
        return {
            selectedUrl: '',
            tableId: 'specialization',
            deleteModalId: 'specialization-delete-modal',
            rowData: {},
            options: {
                url: SPECIALIZATION,
                name: 'specialization',
                datatableWrapper: false,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        key: 'edit',
                        modifier: () => this.$have('PERMISSION_UPDATE_COMPANY_LOCATION')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        key: 'delete',
                        modifier: () => this.$have('PERMISSION_DELETE_COMPANY_LOCATION')
                    }
                ],
                showAction: (this.$have('PERMISSION_UPDATE_COMPANY_LOCATION') || this.$have('PERMISSION_DELETE_COMPANY_LOCATION')),
                rowLimit: 10,
                orderBy: 'desc',
                tableShadow: false,
                actionType: 'default'
            },
            isSpecializationAddEditModalActive: false,
            isSpecializationDeleteModalActive: false,
        }
    },
    beforeMount() {
        if (this.$have('PERMISSION_UPDATE_COMPANY_LOCATION') || this.$have('PERMISSION_DELETE_COMPANY_LOCATION')) {
            this.options.columns.push({
                title: this.$t('actions'),
                type: 'action'
            })
        }
    },
    mounted() {
        this.addSpecialization();
    },
    methods: {
        addSpecialization() {
            this.$hub.$on(`headerButtonClicked-${this.id}`, () => {
                this.openSpecializationAddEditModal();
            })
        },
        getTableAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title === this.$t('edit')) {
                this.openSpecializationAddEditModal();
                this.selectedUrl = `${SPECIALIZATION}/${rowData.id}`;
            } else if (actionObj.title === this.$t('delete')) {
                this.openLocationDeleteModal();
            }
        },
        openSpecializationAddEditModal() {
            this.isSpecializationAddEditModalActive = true;
        },
        closeLocationAddEditModal() {
            this.selectedUrl = '';
            this.isSpecializationAddEditModalActive = false;
        },
        openLocationDeleteModal() {
            this.isSpecializationDeleteModalActive = true;
        },
        closeDeleteModal() {
            this.isSpecializationDeleteModalActive = false
        },
        confirmDelete() {
            this.deleteAndReload(`${SPECIALIZATION}/${this.rowData.id}`);
        },
        cancelDelete() {
            $(`#${this.deleteModalId}`).modal('hide');
            this.closeDeleteModal();
        },
    }
}